//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import Translator from '@/services/translator'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-create',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        currentEmployee() {
            return this.user.hr_employee
        },

        /**
         * @description
         * create fields props
         */
        fieldsProps() {
            return {
                g_branch_office_id: this.currentEmployee.g_branch_office_id,
                is_service: this.formData.is_service,
                pch_provider_branch_offices: this.formDataBranchOffices,
                pch_provider_id: this.pch_provider_id,
                pch_provider_id_trigger: this.setFormDataBranchOffice,
                selected_mapper: this.toCreateProductServiceSelected,
                selected_method: this.toCreateProductService,
                selected_error: this.error,
                selected_success: this.successCreateProductService,
            }
        },

        /**
         * @description
         */
        formProps() {
            return {
                fields: fields(this.fieldsProps),
            }
        },

        /**
         *
         */
        pch_provider_id() {
            return this.formData.pch_provider_id
        },
    },
    data() {
        return {

            // temp data
            aux_wh_product_service_price: 0,
            aux_wh_product_service_provider_code: '',
            aux_wh_product_service_quantity: 0,

            // model data
            formData: new PurchaseOrderModel({
                is_exent: false,
                is_service: false,
                pch_provider_id: null,
                pch_provider_branch_offices_id: 0,
                pch_selected_purchase_orders: [],
            }),

            // branch offices
            formDataBranchOffices: [],
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
        }),

        /**
         * @description
         */
        create(model) {
            model
                .toCreate()
                .save()
                .then(this.success)
                .then(this.redirect)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },

        /**
         * @description
         */
        redirect() {
            this.$router.push({ name: 'purchase-order-list' })
        },

        /**
         * @description
         */
        reset() {
            this.formData.fetchProductServiceIndicator()
        },

        /**
         * @description
         */
        setFormData(model) {
            this.formData = model.reset()
        },

        /**
         * @description
         */
        setFormDataBranchOffice(ctx) {

            //
            const fieldset = ctx.getFieldset()
            const provider = ctx.getInput('pch_provider_id')
            const table = ctx.getInput('pch_selected_purchase_orders')
            const { branch_offices } = provider.getSelected()

            // set new items
            this.formDataBranchOffices = branch_offices || []

            // reset fieldset
            fieldset.$forceUpdate()
            table.$refs.toolbar.$refs.tablePicker.$refs.table.refresh()
        },

        /**
         * @description
         */
        error(error) {
            this.setErrorSnackbar(
                Translator(PurchaseOrderModel, error.response.data)
            )
        },
        /**
         * 
         */
        showRemoveError(event) {
            console.log({ event })
            this.showErrorSnackbar('No se pudo eliminar el producto servicio.')
        },
        /**
         * 
         */
        showRemoveSuccess() {
            this.showSuccessSnackbar('Producto servicio eliminado exitosamente.')
        },
        /**
         * @description
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },

        submitRemove(event) {
            //
            this.showWarningSnackbar({
                title: 'Eliminar producto servicio',
                message: '¿Esta seguro en eliminar el producto servicio seleccionado?',
                confirm: 'eliminar',
            })
            //
            this.selected = event.item
        },

        /**
         * @description
         * submit service switch
         */
        submitService() {
            this.formData.collection('pch_selected_purchase_orders').clean()
        },

        /**
         * @description
         */
        success() {
            this.setSuccessSnackbar('Orden de compra creada exitosamente.')
        },

        /**
         * @description
         */
        successCreateProductService() {
            this.setSuccessSnackbar('Servicio agregado exitosamente.')
            this.$refs.form.getInput('pch_selected_purchase_orders').$refs.toolbar.$refs.tablePicker.$refs.table.refresh()
        },

        /**
         * @description
         * create wh product service
         */
        toCreateProductService(model) {

            //
            this.aux_wh_product_service_price = model.price
            this.aux_wh_product_service_provider_code = model.provider_code
            this.aux_wh_product_service_quantity = model.quantity

            //
            return model.toCreate().save()
        },

        /**
         * @description
         * create wh product service
         */
        toCreateProductServiceSelected(model) {

            //
            var aux_wh_product_service = model.toDetailPurchaseOrder()

            //
            aux_wh_product_service.net_price = this.aux_wh_product_service_price
            aux_wh_product_service.provider_product_code = this.aux_wh_product_service_provider_code
            aux_wh_product_service.quantity = this.aux_wh_product_service_quantity

            //
            return aux_wh_product_service
        },
        /**
         * 
         */
        toRefreshTablePicker() {
            return this
                .$refs
                .form
                .$refs
                .fieldset
                .$refs
                .pch_selected_purchase_orders[0]
                .$refs
                .toolbar
                .$refs
                .tablePicker
                .$refs
                .table
                .refresh()
        },
        /**
         * 
         */
        toRemove() {
            return this
                .selected
                .delete()
                .then(this.showRemoveSuccess)
                .then(this.toRefreshTablePicker)
                .catch(this.showRemoveError)
        }
    },
    watch: {
        responseConfirmSnackbar(value) {
            switch(value) {
                case 'eliminar': return this.toRemove()
            }
        },
        'formData.is_service'(value) {
            if(value) {
                this.$refs.form.getInput('wh_warehouse_id').setFirst()
            }
        }
    },
    beforeMount() {
        this.setTitleTopBar('Crear orden de compra')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
